import { LayoutDashboard, Building2, FileText, Calendar, CalendarDays, Receipt, Users, Briefcase } from "lucide-react";
import { NavRoute } from "models/routes";

export const navRoutes = [
	{
		to: "/",
		title: "Dashboard",
		icon: LayoutDashboard,
	},
	{
		to: "/properties",
		title: "Properties",
		icon: Building2,
	},
	{
		to: "/reservations",
		title: "Reservations",
		icon: Calendar,
	},
	{
		to: "/calendar",
		title: "Calendar",
		icon: CalendarDays,
	},
	{
		to: "/guests",
		title: "Guests",
		icon: Users,
	},
	{
		to: "/statements",
		title: "Statements",
		icon: FileText,
	},
	{
		to: "/expenses",
		title: "Expenses",
		icon: Receipt,
	},
	{
		to: "/services",
		title: "My Services",
		icon: Briefcase,
		children: [
			{ to: "/services/agreements", title: "Agreements" },
			{ to: "/services/property-details", title: "Property Details" },
		],
	},
] as Array<NavRoute>;
